var CategoryInfo = {
	lastCategory:"",
	lastLevel:"",
	lastIcon:"",

	init: function() {
		AppEvent.on(player, "PLACE.LOADED", CategoryInfo.onPlaceLoad);
		AppEvent.on(player, "HOTSPOT.STARTLOOKING", CategoryInfo.onLookAt);
		AppEvent.on(player, "PLAYER.GO", CategoryInfo.onGo);
		CategoryInfo.flash = $("<div id='category_info'></div>");
		$("#overlay").append("<div id='ci_bg'></div>");
		$("#overlay").append(CategoryInfo.flash);
		$("#overlay").append("<div id='ci_cat'></div>");
		$("#overlay").append("<div id='ci_level'></div>");
		$("#overlay").append("<div id='ci_icon'><div class='icon'></div></div>");
		$("#overlay").append("<div id='ci_infoicon'><img src='assets/menu_info.png'></div>");
		$("#ci_infoicon").on(Events.pointer.down, function() {SpeechManager.speakTip("PLAYER.HELP.4.TITLE", "TIPS");placeInfo.toggleMenu();});

		SpeechManager.prepareTip("PLAYER.HELP.4.TITLE", "TIPS");

		$("#overlay").append("<div id='ci_status'></div>");

		window.setStatus = function(str) {
			$("#ci_status").html(str);
			if (str == "") $("#ci_status").css("visibility", "hidden");
			else $("#ci_status").css("visibility", "visible");
		};
	},

	onLookAt: function(spot) {
		//console.log("onLookAt");
		//console.log(spot);
		CategoryInfo.selectedSpot = spot;
	},

	onGo: function(data) {
		if (CategoryInfo.selectedSpot != null) {
			var icon = CategoryInfo.selectedSpot.properties.place.iconfile;

			if (CategoryInfo.lastIcon != icon) {
				if (icon != null && icon != "null" && icon != "") {
					$("#ci_icon .icon").css("background-image","url(/html5app/storage/plan/" + icon + ")");
					$("#ci_icon").show();
					$("#ci_icon").removeClass("icon_fade_in");				
					$("#ci_icon").removeClass("icon_fade_out");				
					setTimeout(function() {$("#ci_icon").addClass("icon_fade_in");}, 100);
				} else {
					$("#ci_icon").addClass("icon_fade_out")
					setTimeout(function() {$("#ci_icon").removeClass("icon_fade_in");}, 100);
				}
			}

			CategoryInfo.lastIcon = icon;
		}
	},

	onPlaceLoad: function(place) {
		console.log("Last folder: " + CategoryInfo.lastFolder);
		console.log("Current folder: " + player.current.folder.city_id);

		if (CategoryInfo.lastFolder != undefined && CategoryInfo.lastFolder != player.current.folder.city_id && parseInt(player.current.priority) < 9 && player.current.folder.silent == 0) {
			$("#ci_bg").css("opacity","1");
			$("#ci_bg").css("visibility","visible");
			$("#category_info").html(player.current.folder.city_name);
			setTimeout(function() {
				$("#category_info").css("opacity","1");
			}, 500);

			setTimeout(function() {
				$("#ci_bg").css("opacity","0");
				$("#category_info").css("opacity","0");
				setTimeout(function() {
					$("#ci_bg").css("visibility","hidden");
				}, 500);
			}, 3000);
		}

		CategoryInfo.lastFolder = player.current.folder.city_id;

		//console.log(player.current);
		//console.log("Desc: " + (player.current.description != "" ? "YES" : "NO"));
		window.setStatus("");
		
		if (player.current.description != "" && player.current.description != undefined) {
			$("#ci_infoicon").show();
			if (player.current.place_type == "photo") {
				$("#ci_infoicon").addClass("photo");
				//$("#ci_infoicon").css("left", "23px");
				//$("#ci_infoicon").css("top", "23px");
			} else {
				$("#ci_infoicon").removeClass("photo");
				//$("#ci_infoicon").css("left", "23px");
				//$("#ci_infoicon").css("top", "63px");
			}
		} else {
			$("#ci_infoicon").hide();
		}

		if (player.current.psc_name == null) return;

		var li = "";
		if (player.current.plan_level == 0 && player.current.psc_floor0 != "" && player.current.psc_floor0 != null) li = player.current.psc_floor0;
		if (player.current.plan_level < 0 && player.current.psc_basement != "" && player.current.psc_basement != null) li = player.current.psc_basement;
		if (player.current.plan_level > 0 && player.current.psc_floorname != "" && player.current.psc_floorname != null) li = player.current.psc_floorname + " " + player.current.plan_level;

		li = li != "" ? ", " + li : "";

		var s = $("#info .label").html();
		$("#info .label").html(s + "<br><small>" + player.current.psc_name + li + "</small>");
		/*
		if (player.current.psc_name != "") $("#ci_cat").show(); else $("#ci_cat").hide();
		$("#ci_cat").html(player.current.psc_name);

		if (li != "") $("#ci_level").show(); else $("#ci_level").hide();

		$("#ci_level").html(li);
		*/

		/*
		if (player.current.iconfile != null && player.current.iconfile != "null" && player.current.iconfile != "") {
			$("#ci_icon .icon").css("background-image","url(/storage/plan/" + player.current.iconfile + ")");
			$("#ci_icon").show();
			$("#ci_icon").removeClass("icon_fade");
			setTimeout(function() {$("#ci_icon").addClass("icon_fade");}, 100);
		}
		*/

		if (player.current.psc_name != CategoryInfo.lastCategory) {

			var levelInfo = "";
			if (player.current.level == 0 && player.current.psc_floor0 != "" && player.current.psc_floor0 != null) levelInfo = "<br>" + player.current.psc_floor0;
			if (player.current.level < 0 && player.current.psc_basement != "" && player.current.psc_basement != null) levelInfo = "<br>" + player.current.psc_basement;
			if (player.current.level > 0 && player.current.psc_floorname != "" && player.current.psc_floorname != null) levelInfo = "<br>" + player.current.psc_floorname + " " + player.current.level;
			
			$("#category_info").html(player.current.psc_name + "<span class='level'>" + levelInfo + "</span>");
			$("#category_info").css("opacity","1");
			setTimeout(function() {
				$("#category_info").css("opacity","0");
			}, 6000);

		} else if (player.current.level != CategoryInfo.lastLevel) {
			var levelInfo = "";
			if (player.current.level == 0 && player.current.psc_floor0 != "" && player.current.psc_floor0 != null) levelInfo = "<br>" + player.current.psc_floor0;
			if (player.current.level < 0 && player.current.psc_basement != "" && player.current.psc_basement != null) levelInfo = "<br>" + player.current.psc_basement;
			if (player.current.level > 0 && player.current.psc_floorname != "" && player.current.psc_floorname != null) levelInfo = "<br>" + player.current.psc_floorname + " " + player.current.level;
			
			$("#category_info").html("<span class='level'>" + levelInfo + "</span>");
			$("#category_info").css("opacity","1");
			setTimeout(function() {
				$("#category_info").css("opacity","0");
			}, 6000);

		}

		CategoryInfo.lastCategory = player.current.psc_name;
		CategoryInfo.lastLevel = player.current.level;
	}
}

PluginManager.add(CategoryInfo);